(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["rapierific-christmas-popup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rapierific-christmas')) {
    customElements.define('rapierific-christmas', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.dialog = this.querySelector('dialog');
        this.deadline = Date.parse(this.dataset.deadline);
        this.key = 'rapierific-christmas-2026-dismissed';
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.querySelector('.rp-xmas__close').addEventListener('click', () => this.dialog.close(), options);
        this.querySelector('.rp-xmas__cta').addEventListener('click', () => this.dialog.close(), options);
        this.dialog.addEventListener('close', () => {
          clearInterval(this.ticker);
          document.documentElement.classList.remove('rp-xmas-open');
          try { localStorage.setItem(this.key, String(Date.now())); } catch {}
        }, options);
        this.dialog.addEventListener('click', event => {
          if (event.target !== this.dialog) return;
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
        }, options);
        document.addEventListener('shopify:section:select', event => {
          if (event.detail.sectionId === this.dataset.sectionId) this.open();
        }, options);
        const forcePreview = new URLSearchParams(location.search).get('rp_christmas_preview') === '1';
        let dismissed = false;
        try {
          dismissed = Date.now() - Number(localStorage.getItem(this.key) || 0) < Number(this.dataset.days) * 86400000;
        } catch {}
        if (!dismissed || forcePreview || window.Shopify?.designMode) {
          this.timeout = setTimeout(() => this.open(), window.Shopify?.designMode || forcePreview ? 300 : Number(this.dataset.delay) * 1000);
        }
      }
      open() {
        if (!this.isConnected || this.dialog.open || !Number.isFinite(this.deadline) || Date.now() >= this.deadline) return;
        if (document.querySelector('dialog[open]')) return;
        const art = this.querySelector('[data-art]');
        if (art) { art.replaceWith(art.content.cloneNode(true)); }
        this.tick();
        this.dialog.showModal();
        document.documentElement.classList.add('rp-xmas-open');
        this.ticker = setInterval(() => this.tick(), 1000);
      }
      tick() {
        const seconds = Math.max(0, Math.floor((this.deadline - Date.now()) / 1000));
        const values = { days: Math.floor(seconds / 86400), hours: Math.floor(seconds / 3600) % 24, minutes: Math.floor(seconds / 60) % 60, seconds: seconds % 60 };
        for (const [unit, value] of Object.entries(values)) this.querySelector('[data-unit="' + unit + '"]').textContent = String(value).padStart(2, '0');
        if (seconds === 0 && this.dialog.open) this.dialog.close();
      }
      disconnectedCallback() {
        clearTimeout(this.timeout);
        clearInterval(this.ticker);
        this.controller?.abort();
        if (this.dialog?.open) this.dialog.close();
        document.documentElement.classList.remove('rp-xmas-open');
        this.ready = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rapierific-collections"] && !Shopify.designMode) return;
  try {
    
function initializeRapierificCatalog(){document.querySelectorAll('.rc:not(.rc-ready)').forEach(root=>{root.classList.add('rc-ready');root.querySelector('.rc-sort select')?.addEventListener('change',event=>event.target.form.requestSubmit());root.querySelectorAll('.rc-filter').forEach(panel=>panel.addEventListener('toggle',()=>{if(panel.open)root.querySelectorAll('.rc-filter').forEach(other=>{if(other!==panel)other.open=false;});}));document.addEventListener('click',event=>{if(!root.contains(event.target))root.querySelectorAll('.rc-filter').forEach(panel=>panel.open=false);});root.addEventListener('keydown',event=>{if(event.key==='Escape')root.querySelectorAll('.rc-filter').forEach(panel=>{if(panel.open){panel.open=false;panel.querySelector('summary').focus();}});});});}initializeRapierificCatalog();document.addEventListener('shopify:section:load',initializeRapierificCatalog);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rapierific-knowledge"] && !Shopify.designMode) return;
  try {
    
function initializeRapierificBlogs(scope=document){scope.querySelectorAll('.rb:not([data-ready])').forEach(root=>{root.dataset.ready='true';let topic='all',search='';const input=root.querySelector('input[type=search]'),cards=[...root.querySelectorAll('.rb-story')],buttons=[...root.querySelectorAll('[data-topic]')],feature=root.querySelector('[data-feature]');function update(){let count=0;cards.forEach(card=>{const visible=(topic==='all'||card.dataset.category===topic)&&card.dataset.search.includes(search);card.hidden=!visible;if(visible)count++;});if(feature)feature.hidden=!(topic==='all'||topic==='buying')||Boolean(search);root.querySelector('.rb-empty').hidden=count>0;buttons.forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.topic===topic)));}root.querySelector('form').addEventListener('submit',event=>{event.preventDefault();search=input.value.trim().toLowerCase();update();});input.addEventListener('input',()=>{if(!input.value){search='';update();}});buttons.forEach(button=>button.addEventListener('click',()=>{topic=button.dataset.topic;update();}));root.querySelector('[data-reset]').addEventListener('click',()=>{topic='all';search='';input.value='';update();});});}initializeRapierificBlogs();document.addEventListener('shopify:section:load',()=>initializeRapierificBlogs());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rapierific-offer-ticker"] && !Shopify.designMode) return;
  try {
    
function setupRapierificTicker(){document.querySelectorAll('.rp-ticker-toggle:not([data-ready])').forEach(button=>{button.dataset.ready='true';button.addEventListener('click',()=>{const paused=button.closest('.rp-ticker').classList.toggle('rp-paused');button.setAttribute('aria-pressed',String(paused));button.setAttribute('aria-label',paused?button.dataset.resume:button.dataset.pause);button.querySelector('span').textContent=paused?'▶':'Ⅱ';});});}setupRapierificTicker();document.addEventListener('shopify:section:load',setupRapierificTicker);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-bar"] && !Shopify.designMode) return;
  try {
    
  let top_bar = document.querySelector('.section-top-bar')?.clientHeight || 0;
  const body = document.querySelector('body');
  body.style.setProperty('--height-topbar', `${top_bar}px`);

  } catch(e) { console.error(e); }
})();
})();
